"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabaseQueryWrapper = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var DatabaseQueryGql_1 = require("../../queries/DatabaseQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
var ErrorMessageWidgets_1 = require("../widgets/ErrorMessageWidgets");
var DatabaseQueryWrapper = /** @class */ (function (_super) {
    __extends(DatabaseQueryWrapper, _super);
    function DatabaseQueryWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderDatabaseData = function (data) {
            var database = data.databases ? data.databases[0] : null;
            if (database) {
                return _this.props.children(database);
            }
            else {
                return React.createElement(data_catalog_shared_1.CenteredMessage, { message: Localize_1.Messages.ErrorItemNotFound() });
            }
        };
        return _this;
    }
    DatabaseQueryWrapper.prototype.render = function () {
        var _this = this;
        return (React.createElement(react_apollo_1.Query, { query: DatabaseQueryGql_1.DatabaseQueryGql, variables: {
                databaseId: this.props.databaseId,
            } }, function (result) { return renderQueryResult_1.renderQueryResult(result, {
            renderLoading: function () { return React.createElement(data_catalog_shared_1.CenteredFadeInSpinner, null); },
            renderData: _this.renderDatabaseData,
            renderNoData: ErrorMessageWidgets_1.renderNoData,
            renderDataWithError: ErrorMessageWidgets_1.createRenderDataWithErrorFunction(_this.renderDatabaseData),
            renderError: ErrorMessageWidgets_1.renderError,
        }); }));
    };
    return DatabaseQueryWrapper;
}(React.Component));
exports.DatabaseQueryWrapper = DatabaseQueryWrapper;
// export type DatabaseQueryWrapperWithCertificationProps = {
//   readonly databaseId: string;
//   readonly children: (result: DatabaseQueryWithCertifications_databases) => React.ReactNode;
// };
// export function DatabaseQueryWrapperWithCertification(props: DatabaseQueryWrapperWithCertificationProps): JSX.Element {
//   return (
//     <Query<DatabaseWithCertificationsQuery, DatabaseWithCertifications>
//       query={DatabaseQueryGql}
//       variables={{
//         databaseId: this.props.databaseId,
//       }}
//     >
//       {result => renderQueryResult(result, {
//         renderLoading: () => <CenteredFadeInSpinner />,
//         renderData: this.renderDatabaseData,
//         renderNoData: renderNoData,
//         renderDataWithError: createRenderDataWithErrorFunction(this.renderDatabaseData),
//         renderError: renderError,
//       })}
//     </Query>
//   );
// }
//# sourceMappingURL=DatabaseQueryWrapper.js.map